import { Node as TiptapNode, mergeAttributes } from '@tiptap/core';
import {
  NodeViewContent,
  ReactNodeViewRenderer,
  NodeViewWrapper,
} from '@tiptap/react';

export const RlGroupedSectionTempName = 'RL_GROUPED_SECTION_TEMP';

const GroupedSectionTempNodeView = () => {
  return (
    <NodeViewWrapper
      contentEditable={false}
      className={'custom-section-content'}
    >
      <NodeViewContent />
    </NodeViewWrapper>
  );
};

export const RlGroupedSectionTemp = TiptapNode.create({
  name: RlGroupedSectionTempName,

  group: 'block',
  content: 'block*',

  isolating: true,
  defining: true,
  draggable: true,
  selectable: false,
  allowGapCursor: true,

  marks: '',
  atom: false,
  addAttributes() {
    return {
      tempId: {
        default: '-1',
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: `div[data-type="${this.name}"]`,
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        ['data-type']: this.name,
        contenteditable: 'false',
      }),
      0,
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(GroupedSectionTempNodeView, {
      as: 'section',
      className: 'custom-section',
    });
  },
});
